import { useEffect, useState } from "react";

/** Phone layout (`max-width: 48rem`). */
export const NARROW_VIEWPORT_QUERY = "(max-width: 48rem)";

/** Phone and tablet layout (`max-width: 64rem`). */
export const COMPACT_VIEWPORT_QUERY = "(max-width: 64rem)";

function readQuery(query: string): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia(query).matches;
}

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => readQuery(query));

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const media = window.matchMedia(query);
    const sync = () => setMatches(media.matches);
    sync();
    media.addEventListener("change", sync);
    return () => media.removeEventListener("change", sync);
  }, [query]);

  return matches;
}

export function useNarrowViewport(): boolean {
  return useMediaQuery(NARROW_VIEWPORT_QUERY);
}

export function useCompactViewport(): boolean {
  return useMediaQuery(COMPACT_VIEWPORT_QUERY);
}
